import React, {ReactNode, useState} from "react";
import {Link} from "react-router-dom";
import ChatProductModal, {openInModal} from "./ChatProductModal";

/**
 * Ссылка на товар в тексте ответа консультанта: открывает страницу товара в модальном окне, чат остаётся на месте.
 */
export default function ChatProductLink({productId, href, children}: {productId: number, href: string, children: ReactNode}) {
    const [open, setOpen] = useState(false);

    return <>
        <Link className="chat-link" to={href} onClick={event => openInModal(event, () => setOpen(true))}>{children}</Link>
        <ChatProductModal productId={productId} href={href} show={open} onHide={() => setOpen(false)}/>
    </>;
}
